import Text from '@ui/text/text/text';

type EditProjectErrorBoundaryProps = {
  label?: string;
};

const EditProjectErrorBoundary = ({ label }: EditProjectErrorBoundaryProps) => {
  return (
    <div className="padding-30">
      <Text tag="h3" color="var(--semantic-red-500)" className="H3">
        {label || 'An error occurred while loading the project.'}
      </Text>
    </div>
  );
};

export default EditProjectErrorBoundary;
